import * as readline from 'node:readline';
import type { LogFn } from '../log.js';

export function installE2eCertificateKeyCommand({
  log,
  onOpenCertificate,
  onInterrupt,
}: {
  log: LogFn;
  onOpenCertificate: () => void;
  onInterrupt: () => void;
}): () => void {
  if (!process.stdin.isTTY || typeof process.stdin.setRawMode !== 'function') {
    log('[E2EE] Press c to import the E2EE key in a browser when running in an interactive terminal.');
    return () => {};
  }

  readline.emitKeypressEvents(process.stdin);
  process.stdin.setRawMode(true);
  process.stdin.resume();

  const onKeypress = (str: string, key: readline.Key) => {
    if (key?.ctrl && key.name === 'c') {
      onInterrupt();
      return;
    }
    if (!key?.ctrl && !key?.meta && (key?.name === 'c' || str === 'c')) {
      onOpenCertificate();
    }
  };

  process.stdin.on('keypress', onKeypress);
  log('[E2EE] Press c to import the active E2EE key into the browser.');

  return () => {
    process.stdin.off('keypress', onKeypress);
    if (process.stdin.isTTY && typeof process.stdin.setRawMode === 'function') {
      process.stdin.setRawMode(false);
    }
  };
}
